const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/task-assignment/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/supervisor/task-assignment')({
  beforeLoad: requireCapabilities(has => has('manual-task.requests.read')),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});